export const ROLE_HOME = { waiter: '/waiter', cashier: '/cashier', kitchen: '/kitchen' };
export const homeFor = (user) => ROLE_HOME[user?.role] || '/dashboard';
export const isAdmin = (user) => ['business_admin', 'super_admin'].includes(user?.role);
